module.exports = __webpack_public_path__ + "img/img.efb29010.png";